import { useQuery } from 'react-query';
import { IPaginationParams } from '../../../../types';
import {
  getAllSchoolMonitoringEventByLicenseAsync,
  getAllSchoolMonitoringEventCountByLicenseAsync,
} from '../../index';
import { ISchoolMonitoringFilterProps } from '../../types';

export const SCHOOL_MONITORING_KEYS = {
  ALL: 'schoolMonitoring',
  LIST: 'list',
  COUNT: 'count',
};

export const useGetAllSchoolMonitoringEventByLicenseQuery = (
  pagination?: IPaginationParams,
  filter?: ISchoolMonitoringFilterProps,
  enabled: boolean = true,
) => {
  return useQuery(
    [SCHOOL_MONITORING_KEYS.ALL, SCHOOL_MONITORING_KEYS.LIST, pagination, filter],
    () => getAllSchoolMonitoringEventByLicenseAsync(pagination, filter),
    {
      enabled,
      keepPreviousData: true,
      staleTime: 0,
      refetchOnWindowFocus: true,
    }
  );
};

export const useGetAllSchoolMonitoringEventCountByLicenseQuery = (
  filter?: ISchoolMonitoringFilterProps,
  enabled: boolean = true,
) => {
  return useQuery(
    [SCHOOL_MONITORING_KEYS.ALL, SCHOOL_MONITORING_KEYS.COUNT, filter],
    () => getAllSchoolMonitoringEventCountByLicenseAsync(filter),
    { 
      enabled,
      staleTime: 0, 
      refetchOnWindowFocus: true,
    },
  );
};